{
  // --- Grid view toggle (mobile) ---
  if (window.innerWidth < 1025) {
    document.querySelectorAll('.coll-view span').forEach((span) => {
      span.addEventListener('click', () => {
        const viewClass = span.dataset.view;
        const siblings = span.closest('li').parentElement.querySelectorAll('li span');
        siblings.forEach((s) => s.classList.remove('active'));
        span.classList.add('active');

        const grid = document.querySelector('.collection-grid');
        grid?.classList.remove('view-1', 'view-2');
        grid?.classList.add(viewClass);
      });
    });
  }

  // Init swatches (or defer if product-group-swatches.js hasn't loaded yet)
  if (window.GroupSwatches) {
    window.GroupSwatches.init();
  } else {
    window.addEventListener('groupswatches:ready', () => window.GroupSwatches?.init(), { once: true });
  }

  // --- Helpers shared by load-more & preload ---
  const reinitCards = () => {
    if (typeof quickAddButton === 'function') quickAddButton();
    window.GroupSwatches?.init();
    window.initProductCardVideos?.();
  };

  // --- Load More ---
  const initLoadMore = () => {
    const collectionGrid = document.getElementById('collection-grid');
    const pagination = document.getElementById('collection-pagination');
    if (!collectionGrid || !pagination || pagination.dataset.paginationMode !== 'load') return;

    const { sectionId, perPage: rawPerPage, totalProducts: rawTotal, totalPages: rawPages, currentPage: rawPage } = pagination.dataset;
    const perPage = parseInt(rawPerPage, 10) || 28;
    const totalProducts = parseInt(rawTotal, 10) || 0;
    const totalPages = parseInt(rawPages, 10) || 1;
    let currentPage = parseInt(rawPage, 10) || 1;
    let loading = false;

    const loader = () => collectionGrid.querySelector('.collection-loader');
    const showLoader = () => { const el = loader(); if (el) el.style.display = 'flex'; };
    const hideLoader = () => { const el = loader(); if (el) el.style.display = 'none'; };

    const updateUrl = (page) => {
      const url = new URL(window.location.href);
      page > 1 ? url.searchParams.set('page', page) : url.searchParams.delete('page');
      history.replaceState({ page }, '', url.pathname + url.search);
    };

    const fetchPage = async (pageUrl) => {
      const sep = pageUrl.includes('?') ? '&' : '?';
      const res = await fetch(`${pageUrl}${sep}section_id=${sectionId}`);
      const html = await res.text();
      return new DOMParser().parseFromString(html, 'text/html');
    };

    const appendProducts = (doc) => {
      const grid = document.getElementById('product-grid');
      const newGrid = doc.getElementById('product-grid');
      if (!grid || !newGrid) return;
      newGrid.querySelectorAll('.product-item, .featured-section').forEach((item) => grid.appendChild(item));
    };

    const updatePagination = (doc) => {
      const container = document.getElementById('collection-pagination');
      const fresh = doc.getElementById('collection-pagination');
      if (container) container.innerHTML = fresh ? fresh.innerHTML : '';
    };

    // Event delegation — survives filter.js innerHTML replacement
    collectionGrid.addEventListener('click', async (e) => {
      const btn = e.target.closest('.collection-load-more');
      if (!btn || loading || !btn.dataset.nextUrl) return;
      e.preventDefault();

      loading = true;
      btn.style.display = 'none';
      showLoader();

      try {
        const doc = await fetchPage(btn.dataset.nextUrl);
        appendProducts(doc);
        reinitCards();
        currentPage++;
        updateUrl(currentPage);
        updatePagination(doc);
      } catch (err) {
        console.error('Load more failed:', err);
        btn.style.display = '';
      }

      hideLoader();
      loading = false;
    });

    // Deep-link preload: if URL has ?page=N, load pages 2..N
    const preload = async () => {
      const urlPage = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
      if (urlPage <= 1) return;

      const cap = Math.min(urlPage, totalPages, 5);
      showLoader();

      for (let p = 2; p <= cap; p++) {
        try {
          const doc = await fetchPage(`${window.location.pathname}?page=${p}`);
          appendProducts(doc);
          if (p === cap) updatePagination(doc);
        } catch (err) {
          console.error(`Preload page ${p} failed:`, err);
          break;
        }
      }

      currentPage = cap;
      reinitCards();
      hideLoader();
    };

    preload();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }
};
